<div *ngIf="imageList" class="op-product-chooser-ellipsis">
    <img *ngFor="let img of imageList" (click)="openSessionDialog(img.small)" height="40" [src]="img.small" alt="">
</div>
